import { RowCellContent, Table, TableBody, TableHeadColumn } from "@dash/table";
import { useTheme } from "@emotion/react";

import { TicketListItemDto } from "@megaron/support-contracts";

import { getSupportTicketListTextColor } from "./supportTicketListTextColor";
import {
  AssigneesCell,
  CreatedAtCell,
  PriorityCell,
  SourceMailboxCell,
  TicketDetailsCell,
  TicketStatusTile,
} from "./SupportTicketsListCells";

type Props = {
  items: TicketListItemDto[];
  basePath: string;
  isLoading: boolean;
};

const labeledHeadingsList = ["Skąd", "Przypisany", "Priorytet", "Data utworzenia"] as const;

export const SupportTicketsTable = ({ items, basePath, isLoading }: Props) => {
  const theme = useTheme();
  const tableColumns: TableHeadColumn<string>[] = [
    {},
    {},
    ...labeledHeadingsList.map(
      (label) =>
        ({
          isSortable: false,
          label,
        } as const),
    ),
  ];

  const getTableRowCellsContent = (item: TicketListItemDto): RowCellContent[] => {
    return [
      {
        isLink: false,
        cellCss: { padding: "0.5rem 0.25rem" },
        element: <TicketStatusTile item={item} />,
      },
      {
        isLink: true,
        cellCss: {
          color: getSupportTicketListTextColor(theme, item.status),
          minHeight: "3rem",
          minWidth: 0,
          overflow: "hidden",
        },
        element: <TicketDetailsCell item={item} />,
      },
      {
        isLink: true,
        element: <SourceMailboxCell item={item} />,
      },
      {
        isLink: true,
        element: <AssigneesCell item={item} />,
      },
      {
        isLink: true,
        element: <PriorityCell item={item} />,
      },
      {
        isLink: true,
        element: <CreatedAtCell item={item} />,
      },
    ];
  };

  return (
    <div css={{ overflow: "auto", margin: "0 -2rem 1rem", padding: "0 2rem" }}>
      <Table columns={tableColumns}>
        <TableBody
          isLoading={isLoading}
          rows={items.map((item) => ({
            id: item.id,
            linkTo: `${basePath}/${item.id}`,
            cellsContent: getTableRowCellsContent(item),
            css: {
              "&:hover": {
                "td:nth-child(2) a > div > div:last-of-type > div:first-of-type": {
                  textDecoration: "underline",
                },
              },
            },
          }))}
        />
      </Table>
    </div>
  );
};
